// extracted by css-extract-rspack-plugin
export default {"field-container":"fetchEntityCheckBox_field-container__nqQnv","fieldContainer":"fetchEntityCheckBox_field-container__nqQnv"};